import React from 'react'

const Button = () => {
  return <button className='bg-blue-700 text-white px-6 py-2 rounded-full'>
    Get Started
  </button>;
}

export default Button